export default "__VITE_ASSET__BmIdQagG__"